module.exports = __webpack_public_path__ + "img/1920_leuco_intro_img1.7bd96036.png";